var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('healthcheck-form',{attrs:{"distribution-id":_vm.distributionId},on:{"submit":_vm.addHealthcheck,"close":function($event){return _vm.$emit('closed')}}})}
var staticRenderFns = []

export { render, staticRenderFns }